import React, { useState, useReducer, useEffect, useContext } from 'react';
import {
  Button,
  message,
  Modal,
  Form, Row, Col,
  Input,
  Divider,
  Menu
} from 'antd';
import {
  DeleteOutlined,
  ExclamationCircleOutlined,
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
  ImportOutlined,
  ExportOutlined,
  DownloadOutlined
} from '@ant-design/icons';
import { Table, Page } from '../../components';
import { default as BuyerNew } from './BuyerNew';
import { default as GoodsList } from './goods';
import { MasterContext } from '../../App';
import {
  getList,
  getListCount,
  insert,
  update,
  deleteById,
  checkCanDelete,
  getNotifyPartById,
  insertNotifyParty,
  getGoodsListByDatetime,
  downloadData,
  downloadTemplate
} from '../../services/Buyer';
import { default as GoodsImport } from './goodsImport';
import './style';

export default React.forwardRef((props, ref) => {
  const { user, currentUser, authorities, port, currency, country, payment } = useContext(MasterContext);
  const [form] = Form.useForm();
  const [isShowNew, setShowNew] = useState(false);
  const [isShowEdit, setShowEdit] = useState(false);
  const [isShowGoods, setShowGoods] = useState(false);
  const [isShowNotifyPart, setShowNotifyParty] = useState(false);
  const [isLoadding, setLoadding] = useState(false);
  const [selectedBuyerId, setSelectedBuyerId] = useState(0);
  const [selectedNotifyPart, setSelectedNotifyPart] = useState({});
  const [keyword, setKeyword] = useState(undefined);
  const [isShowImport, setShowImport] = useState(false);

  const initialState = {
    total_rows: 0,
    rows: [],
    sort: { order: 'desc', sort: 'updated' },
    pagination: { limit: 10, offset: 0 },
    views: []
  };

  const onSearch = (keyword) => {
    setPage(1, state.pagination.limit);
    if ((keyword || '').trim().length === 0) setKeyword(undefined);
    else setKeyword(keyword);
  }

  const onClickNotifyPart = (index) => {
    setSelectedBuyerId(index);
    setShowNotifyParty(true);
  }
  const setPage = (page, pageSize) => {
    dispatch({ type: 'pagination', data: { limit: pageSize, offset: (page - 1) * pageSize } });
  }

  function reducer(state, action) {
    switch (action.type) {
      case 'list':
        return Object.assign({}, state, { rows: action.data });
      case 'total_rows':
        return Object.assign({}, state, { total_rows: action.data });
      case 'pagination':
        return Object.assign({}, state, { pagination: action.data });
      case 'selected':
        const rows = state.rows;
        for (let i = 0; i < rows.length; i++) {
          if ((action.data || []).indexOf(i) > -1) {
            rows[i].selected = true;
          } else {
            rows[i].selected = false;
          }
        }
        return Object.assign({}, state, { rows: rows });
      case 'new':
        return { total: state.total + 1 };
      case 'edit':
        return { total: state.total };
      case 'delete':
        return { total: state.total - 1 };
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  const { rows } = state;
  const selectedBuyer = rows[selectedBuyerId] || {};

  useEffect(() => {
    setLoadding(true);
    var p1 = new Promise((resolve, reject) => {
      getListCount(keyword).then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getList(state.pagination, undefined, keyword).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    Promise.all([p1, p2]).then(values => {
      setLoadding(false);
    });
  }, [state.pagination, keyword]);

  const afterClose = (e) => {

  }

  const setSelected = (selected) => {
    dispatch({ type: 'selected', data: selected });
  }

  const reloadBuyer = () => {
    var p1 = new Promise((resolve, reject) => {
      getListCount().then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getList(state.pagination).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    return Promise.all([p1, p2]).then(values => {
      //setLoadding(false);
    });
  }

  const onClickBuyer = (index) => {
    setSelectedBuyerId(index);
    setShowEdit(true);
  }
  const onClickGoods = (index) => {
    setSelectedBuyerId(index);
    setShowGoods(true);
  }

  const onShowImport = (index) => {
    setSelectedBuyerId(index);
    setShowImport(true);
  }

  const onNewCallback = async (value) => {
    try {
      const key = 'create_buyer';
      console.log('onNewCallback:', value);
      message.loading({ content: '正在新建客户...', key });
      insert(value).then((data) => {
        reloadBuyer().then(() => {
          setShowNew(false);
          message.success({ content: `新建客户成功 [#${value.name_en}]`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onCloseGoodsCallback = async (refresh) => {
    try {
      setShowGoods(false);
      reloadBuyer();
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSaveCallback = async (value) => {
    try {
      const key = 'update_buyer';
      message.loading({ content: '正在修改客户...', key });
      console.log('onSaveCallback:', value);
      update(value.id, value).then((data) => {
        reloadBuyer().then(() => {
          setShowEdit(false);
          message.success({ content: `修改客户成功 [#${value.name_en}]`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDeleteCallback = async (value) => {
    try {
      const key = 'delete_buyer';
      console.log('onDeleteCallback:', value);
      
      const arr = [];
      let datas = [];
      value.forEach(x=> {
        arr.push(new Promise((resolve, reject)=> {
          checkCanDelete(x).then(data=> {
            data.forEach(y=> {
              if (!datas.find(z=>z.po_code === y.po_code)) {
                datas.push(y);
              }
            })
            resolve(data);
          })
        }))
      });
      Promise.all(arr).then(() => {
        if (datas.length > 0 ) {
          Modal.error({
            title: '删除错误',
            content: <span>
              <strong>客户已被下列订单使用，不能删除。</strong><br/>
                {
                  datas.map(x=> {
                    return <div><strong>{x.po_code}</strong> - {x.no}</div>
                  })
                }
            </span>
          });
          return;
        }
        message.loading({ content: `正在删除用户 ...`, key });
        deleteById(value.join(',')).then((data) => {
          reloadBuyer().then(() => {
            message.success({ content: `删除用户成功 `, key, duration: 2 });
          })
        })
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }


  const showDeleteConfirm = () => {
    const deleted = rows.filter(x => x.selected);
    const names = [];
    const ids = [];
    deleted.map((item) => { names.push(<div>{item.name_cn}</div>); ids.push(item.id) })
    Modal.confirm({
      title: '确定删除当前客户吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{names}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteCallback(ids)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onSaveNotifyPart = async () => {
    const values = await form.validateFields();
    try {
      const key = 'insert_nf';
      console.log('onSaveNotifyPart:', values);
      message.loading({ content: `正在更新客户清关公司 ...`, key });
      insertNotifyParty(values.id, values).then(() => {
        reloadBuyer().then(() => {
          message.success({ content: `更新客户清关公司成功 `, key, duration: 2 });
          setShowNotifyParty(false);
        })
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }

  }

  const initValue = [
    { name: 'id', value: rows[selectedBuyerId] && rows[selectedBuyerId].id },
    { name: 'name', value: rows[selectedBuyerId] && rows[selectedBuyerId].notify_party_name },
    { name: 'address1', value: rows[selectedBuyerId] && rows[selectedBuyerId].notify_party_address1 },
    { name: 'address2', value: rows[selectedBuyerId] && rows[selectedBuyerId].notify_party_address2 },
    { name: 'tel', value: rows[selectedBuyerId] && rows[selectedBuyerId].notify_party_tel },
    { name: 'fax', value: rows[selectedBuyerId] && rows[selectedBuyerId].notify_party_fax },
    { name: 'email', value: rows[selectedBuyerId] && rows[selectedBuyerId].notify_party_email },
  ];
  const NotifyParty = (
    <Form
      style={{ padding: '1rem 1rem' }}
      form={form}
      preserve={false}
      onFinish={onSaveNotifyPart}
      fields={initValue}>
      <Form.Item hidden={true} name="id" >
        <Input />
      </Form.Item>
      <Form.Item label="清关公司名称" name="name" rules={[{ required: true, message: '请输入清关公司名称!' }]}>
        <Input autocomplete="off" />
      </Form.Item>
      <Row>
        <Form.Item label="清关公司地址" name="address1" style={{ width: '328px' }} rules={[{ required: true, message: '请输入清关公司地址!' }]}>
          <Input autocomplete="off" />
        </Form.Item>
        <Form.Item name="address2" style={{ width: '320px' }} >
          <Input autocomplete="off" />
        </Form.Item>
      </Row>
      <Form.Item label="电话" name="tel" rules={[{ required: true, message: '请输入清关公司电话!' }]}>
        <Input autocomplete="off" />
      </Form.Item>
      <Form.Item label="传真" name="fax" rules={[{ required: true, message: '请输入清关公司传真!' }]}>
        <Input autocomplete="off" />
      </Form.Item>
      <Form.Item label="邮箱" name="email" rules={[{ required: true, message: '请输入清关公司邮箱!' }]}>
        <Input autocomplete="off" />
      </Form.Item>
      <Divider />
      <Row justify="end">
        <Button icon={<CloseOutlined />}>关 闭</Button>&nbsp;&nbsp;
        <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>保 存</Button>
      </Row>
    </Form>
  );

  const downloadBuyerTemplate = () => {
    const key = 'download';
    message.loading({ content: '正在生成客户模板...', key, duration: 20 });
    
    downloadTemplate("goods_template").then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = "buyer_template_" + new Date().getTime();
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `客户模板生成成功`, key, duration: 2 });
      }
    });
  }
  const downloadBuyer = () => {
    const key = 'download';
    message.loading({ content: '正在生成客户数据...', key, duration: 20 });
    downloadData().then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = "buyer_data_" + new Date().getTime();
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `客户数据生成成功`, key, duration: 2 });
      }
    });
  }

  const newOptionMenu = (
    <Menu>
      {/* <Menu.Item key="1" onClick={() => setShowImport(true)} icon={<ImportOutlined />}>
        <span style={{ padding: '0 1rem', color: 'blue' }}><Button size="small" type="link">从模板导入</Button></span>
      </Menu.Item> */}
      <Menu.Item key="1" onClick={() => downloadBuyer(true)} icon={<ExportOutlined />}>
        <span style={{ padding: '0 1rem', color: 'blue' }}><Button size="small" type="link">导出到Excel</Button></span>
      </Menu.Item>
      <Menu.Divider>
      </Menu.Divider>
      <Menu.Item key="2" onClick={() => downloadBuyerTemplate(true)} icon={<DownloadOutlined />}>
        <span style={{ padding: '0 1rem' }}>下载空白模板</span>
      </Menu.Item>
    </Menu>
  );
  const optionMenu = [
    <div>
      {(authorities.find(x => x === 'delete_buyer') || currentUser.category_id === 1) && <Button onClick={showDeleteConfirm} type="danger" icon={<DeleteOutlined />}>
        <span style={{ padding: '0 1rem' }}>删除客户</span>
      </Button>}
    </div>
  ];
  return (
    <div style={{ padding: '0.5rem 1.5rem' }}  >
      <Table
        showFilter={true}
        onSearch={onSearch}
        onSearchPlaceHolder="请输入客户中文或英文名称"
        setSelectedCallback={setSelected}
        setPageCallback={setPage}
        isLoadding={isLoadding}
        expandable={false}
        hasCheckbox={true}
        optionMenu={optionMenu}
        newOptionMenu={newOptionMenu}
        title="客户管理"
        newLabel="新建客户"
        showNewLabel={authorities.find(x => x === 'create_buyer') || currentUser.category_id === 1}
        showFooter={true}
        rows={state.rows}
        total_rows={state.total_rows}
        onNew={() => setShowNew(!isShowNew)}
        relation={
          {
            payment_id: { data: payment, field: 'name_cn' }
          }
        }
        header={[
          {
            label: '客户代号及名称(英文)', width: '280px', item: 'name_en', sortable: true,
            render: (text, row, index) => {
              return <span>{row.name_nick && '[' + row.name_nick + ']'} <Button
                onClick={() => onClickBuyer(index)}
                type="link"
                size="small"
                style={{ padding: 0 }}>
                {text}
              </Button></span>
            }
          },
          {
            label: '详细地址', width: '380px', item: 'address', render: (text, row, index) => {
              return <span>[{row.country_name}] {text}</span>
            }
          },
          // {
          //   label: '默认港口',width:'140px',  item: 'port_name'
          // },
          {
            label: '清关公司', width: '260px', item: 'notify_party_name', render: (text, row, index) => {
              return <div style={{display:'flex', justifyContent:'space-between'}}><div style={{maxWidth:'220px',whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden'}}>{text}</div><Button onClick={() => onClickNotifyPart(index)} size="small" type="link" icon={<EditOutlined />} /></div>
            }
          },
          {
            label: '产品管理', width: '200px', item: 'goods_count', align: 'right', render: (text, row, index) => {
              return <div>
                <Button onClick={() => onClickGoods(index)} type="link" size="small">{text ? text : 0}</Button>
                <Button onClick={() => onClickGoods(index)} type="link" size="small">手动添加</Button>
                <Button onClick={() => onShowImport(index)} type="link" size="small">批量导入</Button>
              </div>
            }
          },
          {
            label: '业务员', width: '120px', item: 'owner_id', align: 'center', render: (text, row, index) => {
              return <div>{user.find(x => x.id === text).name}</div>
            }
          },
          { label: '备注', width: '120px', item: 'remark' }
        ]}
        bordered={true} />
      <Page
        title="新建客户"
        onCloseCallback={() => setShowNew(!isShowNew)}
        width="1024px"
        body={<BuyerNew mode="new" onCloseCallback={() => setShowNew(false)} onSaveCallback={onNewCallback} />}
        visible={isShowNew}
      />
      <Page
        title={`修改客户 [ ${selectedBuyer.name_en} ]`}
        onCloseCallback={() => setShowEdit(!isShowEdit)}
        width="1024px"
        body={<BuyerNew mode="edit" buyer={rows[selectedBuyerId]} onCloseCallback={() => setShowEdit(false)} onSaveCallback={onSaveCallback} />}
        visible={isShowEdit}
      />
      <Page
        title={`修改客户清关公司 [ ${selectedBuyer.name_en} ]`}
        onCloseCallback={() => setShowNotifyParty(false)}
        width="720px"
        body={NotifyParty}
        visible={isShowNotifyPart}
      />
      <Page
        title={`客户产品明细 [ ${selectedBuyer.name_en} ]`}
        isMaximize={true}
        width="1024px"
        onCloseCallback={onCloseGoodsCallback}
        body={<GoodsList onCloseCallback={onCloseGoodsCallback} buyer={selectedBuyer} />}
        visible={isShowGoods} />
      <Page
        title={`产品批量导入 [ ${selectedBuyer.name_en} ]`}
        isMaximize={true}
        body={
          <GoodsImport
            buyer={selectedBuyer}
            reload={reloadBuyer}
            onCloseCallback={() => setShowImport(false)}
          />}
        onCloseCallback={() => setShowImport(false)}
        visible={isShowImport}
      />
    </div >
  );
});
